import { TAG_TYPES, TagType } from "./index";

export const buildQueryParams = (
  selectedTags: { type: TagType; id: string }[],
) => {
  const isValidTagType = (tagType: TagType) => {
    return TAG_TYPES.some((validType) => validType === tagType);
  };

  const groupedTags = selectedTags.reduce<Record<TagType, string[]>>(
    (acc, tag) => {
      if (isValidTagType(tag.type)) {
        acc[tag.type].push(tag.id);
      }
      return acc;
    },
    { tag_ids: [], status: [], job: [] },
  );

  const queryParams: Partial<Record<TagType, string[]>> = {};

  if (groupedTags.tag_ids.length > 0) {
    queryParams.tag_ids = groupedTags.tag_ids;
  }
  if (groupedTags.status.length > 0) {
    queryParams.status = groupedTags.status;
  }
  if (groupedTags.job.length > 0) {
    queryParams.job = groupedTags.job;
  }

  return queryParams;
};
